import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';
import { GameStatus } from './GameStatus';
import { TeamScores } from './TeamScores';
import { Timer } from './Timer';

export const GameControls: React.FC = () => {
  const navigate = useNavigate();
  const gamePhase = useGameStore((state) => state.gamePhase);
  const winner = useGameStore((state) => state.winner);
  const lastMove = useGameStore((state) => state.lastMove);
  const showFullBoard = useGameStore((state) => state.showFullBoard);
  const endTurn = useGameStore((state) => state.endTurn);
  const undoLastMove = useGameStore((state) => state.undoLastMove);
  const setShowFullBoard = useGameStore((state) => state.setShowFullBoard);
  const { t } = useTranslation();

  const handleBackToMenu = () => {
    navigate('/');
  };

  return (
    <div className="game-controls">
      <div className="game-controls-header">
        <button onClick={handleBackToMenu} className="back-button">
          {t.backToMenu}
        </button>
      </div>
      
      <TeamScores />
      <Timer />
      <GameStatus />
      
      {gamePhase === 'playing' && !winner && (
        <div className="guess-controls">
          <button onClick={endTurn} className="end-turn-button">
            {t.endTurn}
          </button>
          {lastMove && (
            <button onClick={undoLastMove} className="undo-button">
              {t.undoMove}
            </button>
          )}
        </div>
      )}
      
      {winner && (
        <div className="game-over-controls">
          <button 
            onClick={() => setShowFullBoard(!showFullBoard)} 
            className="reveal-board-button"
          >
            {showFullBoard ? t.hideBoard : t.revealBoard}
          </button>
        </div>
      )}
    </div>
  );
};
